import withoutSSR from 'core/components/withoutSSR';

import { Component } from 'react';
import ReactDOM from 'react-dom';

/**
 * Портал для вставки сгенерированных стилей.
 * Делаем это вручную, потому что через styled-jsx не работает.
 * Если использовать напрямую <JSXStyle id={'font-size-changer' + rate}>{rules}</JSXStyle>
 * то все работает локально, но в продакшн сборке стили не вставляются все равно.
 */
class StylesPortal extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('style');
  }

  componentDidMount() {
    document.head.appendChild(this.el);
  }

  componentWillUnmount() {
    document.head.removeChild(this.el);
  }


  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}

export default withoutSSR(StylesPortal);
